import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Bonuses } from './components/Bonuses';
import { UrgencyBar } from './components/UrgencyBar';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '1588253585600852';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Avoid double-injection during hot reloads
    if ((window as any).fbq) {
      try {
        ;
        (window as any).fbq('track', 'PageView');
      } catch {}
      return;
    }
    // Meta Pixel base code
    ;
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode?.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', META_PIXEL_ID);
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-[#EBF5FF] via-white to-[#EBF5FF] font-sans selection:bg-blue-600 selection:text-white" data-id="element-0">
      {/* Meta Pixel <noscript> fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>

      <Hero data-id="element-3" />
      <SocialProofBar data-id="element-4" />
      <Testimonials data-id="element-5" />
      <PainPoints data-id="element-6" />
      <ProductOverview data-id="element-7" />
      <Bonuses data-id="element-8" />
      <UrgencyBar data-id="element-9" />
      <Pricing data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}